<div class="plan-fasting-chart-container">
  <div class="plan-fasting-chart-holder">
    <canvas
      baseChart
      id="canvas"
      [data]="demodoughnutChartData"
      [labels]="doughnutChartLabels"
      [colors]="chartColors"
      height="96"
      width="96"
      [chartType]="doughnutChartType"
      [options]="options"
      id="canvass"
      style="margin-top: -26px; margin-right: -20px"
    >
    </canvas>
    <div class="plan-fasting-chart-title-holder">
      {{ title }}
    </div>
  </div>
</div>
